import { render, staticRenderFns } from "./DisputeResolutionFiles.vue?vue&type=template&id=44438395&scoped=true&"
import script from "./DisputeResolutionFiles.vue?vue&type=script&lang=js&"
export * from "./DisputeResolutionFiles.vue?vue&type=script&lang=js&"
import style0 from "./DisputeResolutionFiles.vue?vue&type=style&index=0&id=44438395&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44438395",
  null
  
)

export default component.exports